import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { FilterHint } from './filter-hint';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';


export const SmartFilter = {
    components: {
        FilterHint
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        parseFilterNumber(value){
            const normalized = String(value ?? '').replace(/\s/g, '').replace(',', '.');
            if(normalized === ''){
                return null;
            }
            const number = Number(normalized);
            return Number.isFinite(number) ? number : null;
        },
        hasFilterRange(item){
            if(!item || !item.VALUES || !item.VALUES.MIN || !item.VALUES.MAX){
                return false;
            }
            const min = this.parseFilterNumber(item.VALUES.MIN.VALUE);
            const max = this.parseFilterNumber(item.VALUES.MAX.VALUE);
            return min !== null && max !== null && min < max;
        },
        initFilterSlider(sliderData, prefix = ''){
            if(!this.hasFilterRange(sliderData)){
                return;
            }

            const inputNum1 = $(this.$el).find('#filterNum1' + prefix),
                inputNum2 = $(this.$el).find('#filterNum2' + prefix),
                slider = this.$el.querySelector('#filterRange' + prefix),
                self = this,
                min = this.parseFilterNumber(sliderData.VALUES.MIN.VALUE),
                max = this.parseFilterNumber(sliderData.VALUES.MAX.VALUE),
                minCur = this.parseFilterNumber(sliderData.VALUES.MIN.HTML_VALUE) ?? min,
                maxCur = this.parseFilterNumber(sliderData.VALUES.MAX.HTML_VALUE) ?? max,
                decimals = Number(sliderData.DECIMALS) || 0;

            if(!slider){
                return;
            }

            const state = JSON.stringify([min, max, minCur, maxCur, decimals]);
            const options = {
                start: [minCur, maxCur],
                connect: true,
                behaviour: 'tap',
                range: { min: min, max: max },
                format: {
                    to: value => Number(value.toFixed(decimals)),
                    from: value => Number(value)
                }
            };

            // SAIT-150: обновление Vue не должно сбрасывать ползунок и незавершённый ввод.
            if(slider.noUiSlider){
                if(slider.dataset.tasRangeState !== state){
                    slider.noUiSlider.updateOptions(options);
                    slider.dataset.tasRangeState = state;
                }
                return;
            }

            noUiSlider.create(slider, options);
            slider.dataset.tasRangeState = state;

            slider.noUiSlider.on('update', function(values, handle){
                const input = handle ? inputNum2 : inputNum1;
                if(input.attr('data-tas-range-editing') === '1'){
                    return;
                }
                const parts = String(values[handle]).split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                input.val(parts.join(','));
            });

            slider.noUiSlider.on('change', function(){
                self.setFilter();
            });

            inputNum1.add(inputNum2).off('.tasFilterRange')
                .on('input.tasFilterRange', function(){
                    $(this).attr('data-tas-range-editing', '1');
                    clearTimeout(self.filterTimeout);
                })
                .on('change.tasFilterRange', function(){
                    const input = $(this),
                        handle = this === inputNum1[0] ? 0 : 1,
                        raw = input.val().replace(/\s/g, ''),
                        values = [null, null];
                    let value = self.parseFilterNumber(raw);
                    if(value === null){
                        value = raw === ''
                            ? slider.noUiSlider.options.range[handle ? 'max' : 'min']
                            : slider.noUiSlider.get()[handle];
                    }
                    input.removeAttr('data-tas-range-editing');
                    values[handle] = value;
                    slider.noUiSlider.set(values);
                    self.setFilter();
                })
                .on('keydown.tasFilterRange', function(event){
                    if(event.key === 'Enter'){
                        event.preventDefault();
                        $(this).trigger('change');
                    }
                });
        },
        setFilterScripts: function(){
            if(!this.filterData){
                return;
            }
            if(this.hasFilterRange(this.filterData.PRICE)){
                this.initFilterSlider(this.filterData.PRICE, '');
            }

            for(let i in this.filterData.ITEMS){
                let item = this.filterData.ITEMS[i];
                if(item.DISPLAY_TYPE == 'A' || item.DISPLAY_TYPE == 'B'){
                    if(this.hasFilterRange(item)){
                        this.initFilterSlider(item, item.ID);
                    }
                }
            }

        },
        // Значения списка: выбранные первыми, остальные в исходном порядке.
        sortedFilterValues(item){
            const values = Object.values(item.VALUES || {});
            return values.filter(val => val.CHECKED).concat(values.filter(val => !val.CHECKED));
        },
        // В свёрнутом списке пять строк; выбрано больше пяти — список открыт целиком.
        filterListLimit(item){
            const checked = Object.values(item.VALUES || {}).filter(val => val.CHECKED).length;
            return checked > 5 ? Infinity : 5;
        },
        isFilterListCollapsible(item){
            return Object.keys(item.VALUES || {}).length > this.filterListLimit(item);
        },
        toggleFilterList(item){
            this.expandedLists[item.ID] = !this.expandedLists[item.ID];
        },
        setFilter(){
            let self = this;
            if(this.filterTimeout){
                clearTimeout(this.filterTimeout);
            }
            this.filterTimeout = setTimeout(function(){

                let searchParams = new URLSearchParams(/*window.location.search*/);

                $(self.$el).find('input').each(function(){
                    if($(this).prop('type') == 'text'){
                        const dataVal = self.parseFilterNumber($(this).attr('data-value')),
                            value = self.parseFilterNumber($(this).val());

                        if(value !== null && value !== dataVal){
                            searchParams.set($(this).prop('name'), String(value));
                        }
                    }

                    if($(this).prop('type') == 'checkbox' && $(this).prop('checked')){
                        searchParams.set($(this).prop('name'), $(this).val());
                    }
                });
                searchParams.set('ajax', 'y');

                showCatalogPreloader();

                const urlParams = new URLSearchParams(window.location.search);

                let searchParamsString = searchParams.toString().replace(/&amp;/g, "&");
                 let path = self.filterData.SECTION ? self.filterData.SECTION : window.location.pathname;

                 let queryPath = path + '?' + searchParamsString;
                 if(urlParams.get('q')){
                    queryPath += '&q=' + urlParams.get('q');
                 }

                BX.ajax.get(
                    queryPath,
                    function(response){
                        response = BX.parseJSON(response);

                        if(response.FILTER_URL){

                            let url = response.FILTER_URL.replace(/&amp;/g, "&");
                            let filterParam = '?get_json=Y';
                            if(url.includes("?")){
                                filterParam = '&get_json=Y';
                            }

                            $.ajax({
                                url: url + filterParam,
                                method: 'GET',
                                async: false,
                                success: (itemsResponse) => {

                                    window.history.pushState( url, self.title , url );

                                    itemsResponse = JSON.parse(itemsResponse);

                                    self.struct[self.structKey].CHILDS = itemsResponse.struct[self.structKey].CHILDS;

                                    self.templateData.filterCount = itemsResponse.templateData.filterCount;

                                    let rootNode = $(self.$el);
                                    for( let i in itemsResponse.struct[self.structKey].CHILDS[self.childKey].componentData.ITEMS){
                                        let item = itemsResponse.struct[self.structKey].CHILDS[self.childKey].componentData.ITEMS[i];
                                        for(let j in item.VALUES){
                                            if(item.VALUES[j].DISABLED){
                                                rootNode.find('#' + item.VALUES[j].CONTROL_ID).parent().addClass('disabled');
                                            }else{
                                                rootNode.find('#' + item.VALUES[j].CONTROL_ID).parent().removeClass('disabled');
                                            }
                                        }
                                    }

                                    hideCatalogPreloader();
                                }
                            });
                        }else{
                            hideCatalogPreloader();
                        }

                        self.filterElemCount = response.ELEMENT_COUNT;
                    }
                );

            }, 1000);
        },
        clearFilter(){
            showCatalogPreloader();
            VplRouter(this.filterData.DEL_FILTER, false, false, false);

            $('.js-filter-mob').removeClass('is-open');
            $('body').removeClass('modal-open');
            $('.js-filter-link').removeClass('is-active');
            $('body').removeClass('filter-open');
            $('.js-panel').addClass('is-active');
        },
        processFilterItemView(event){
            let link = $(event.target);
            if (link.parents('.js-filter-item').hasClass('is-open')) {
                link.parents('.js-filter-item').removeClass('is-open');
                link.parents('.js-filter-item').find('.js-filter-list-wp').slideUp();
            } else {
                link.parents('.js-filter-item').addClass('is-open');
                link.parents('.js-filter-item').find('.js-filter-list-wp').slideDown();
            }
        },
        closeFilter(e){
            $('.js-filter-mob').removeClass('is-open');
            $('body').removeClass('modal-open');
            $('.js-filter-link').removeClass('is-active');
            $('body').removeClass('filter-open');
            $('.js-panel').addClass('is-active');
        }
    },
    beforeUnmount(){
        clearTimeout(this.filterTimeout);
        $(this.$el).find('.js-filter-prev, .js-filter-next').off('.tasFilterRange');
        $(this.$el).find('.js-filter-dragger').each(function(){
            if(this.noUiSlider){
                this.noUiSlider.destroy();
            }
        });
    },
    updated(){
        this.setFilterScripts();
    },
    mounted(){
        this.setFilterScripts();

         function hideBtn(amount, item, btn, list) {
            if (item.length > amount) {
                btn.show();
                list.addClass('is-bigger');
            } else {
                btn.hide();
            }
            };

            const categoryListItems = $('.js-category-filter-list-item'),
                categoryListButton = $('.js-category-filter-list-btn'),
                categoryList = $('.js-category-filter-list');

            if (Number(this.struct[this.structKey].componentData.DEPTH_LEVEL) === 2) {
                categoryList.css({ height: 'auto', overflow: 'inherit' })
                    .removeClass('is-bigger')
                    .addClass('is-show');
                categoryListButton.hide();
            } else {
                hideBtn(8, categoryListItems, categoryListButton, categoryList);
            }

            function clickBtns (btn, list){
                btn.click(function (e) {
                    e.preventDefault();

                    if (!$(this).hasClass('is-show')) {
                    $(this).addClass('is-show');
                    $(this).find('span').text('Свернуть');
                    list.addClass('is-show');
                    list.removeClass('is-bigger');
                    } else {
                    $(this).removeClass('is-show');
                    $(this).find('span').text('Показать ещё');
                    list.removeClass('is-show');
                    list.addClass('is-bigger');
                    }
                });
            };

            clickBtns($('.js-category-filter-list-btn'), $('.js-category-filter-list'));
    },
    data() {
        // expandedLists: ID свойства → список раскрыт кнопкой «Показать ещё»
        return { filterElemCount: 0, expandedLists: {} }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'templateData', 'title']),
        childKey(){
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'SmartFilter'){
                    return i;
                }
            }
        },
        filterData(){
            return this.struct[this.structKey].CHILDS[this.childKey].componentData;
        }
    },
    template: `
        <div class="catalog__leftside js-filter-mob">
            <div class="container">
                <div class="filter js-filter">
                    <form action="" v-if="this.filterData">

                        <div class="filter-head">
                            <div class="filter-head-title">Фильтр</div>
                            <a href="#" class="filter-head-close js-filter-close" @click.prevent="closeFilter($event)">
                                <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                            </a>
                        </div>






                        <div v-if="this.filterData.MENU_SECTIONS" class="filter__category">
                            <div class="filter__category-title">
                                Категория
                            </div>
                            <template v-if="this.filterData.MENU_SECTIONS.TYPE == 'CHILDS'">
                                <template v-for="menuItem in this.filterData.MENU_SECTIONS.SECTIONS">

                                    <div v-if="menuItem.CHILDS" class="filter__category-list-wp">

                                        <a v-if="menuItem.MAKE_LINK && menuItem.MAKE_LINK === true" :href="menuItem.URL" class="filter__category-list-name">{{menuItem.NAME}}</a>
                                        <p v-else class="filter__category-list-name">{{menuItem.NAME}}</p>

                                        <div class="filter__category-list js-category-filter-list">

                                            <a v-for="childItem in menuItem.CHILDS" :href="childItem.URL" class="filter__category-list-item js-category-filter-list-item" :class="{'is-active': childItem.CHOOSEN && childItem.CHOOSEN === true}">{{childItem.NAME}}</a>

                                        </div>
                                        <a href="#" class="filter__category-list-btn js-category-filter-list-btn">
                                            <span>Показать ещё</span>
                                            <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                        </a>
                                    </div>

                                    <a v-else :href="menuItem.URL" class="filter__category-name">
                                        <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                        {{menuItem.NAME}}
                                    </a>

                                </template>
                            </template>
                            <template v-else>
                                <div class="filter__category-list-wp">
                                    <template v-for="menuItem in this.filterData.MENU_SECTIONS.SECTIONS">
                                        <a  :href="menuItem.URL" class="filter__category-list-name">{{menuItem.NAME}}</a>
                                        <template v-if="menuItem.CHILDS">
                                            <div class="filter__category-list js-category-filter-list">
                                                <a v-for="childItem in menuItem.CHILDS" :href="childItem.URL" class="filter__category-list-item js-category-filter-list-item" :class="{'is-active': childItem.CHOOSEN && childItem.CHOOSEN === true}">{{childItem.NAME}}</a>
                                            </div>
                                            <a href="#" class="filter__category-list-btn js-category-filter-list-btn">
                                                <span>Показать ещё</span>
                                                <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                            </a>
                                        </template>
                                    </template>
                                </div>
                            </template>
                        </div>






                        <div v-if="!this.struct[this.structKey].componentData.DEPTH_LEVEL || this.struct[this.structKey].componentData.DEPTH_LEVEL > 2" class="filter__item-wp">
                            <div v-if="this.filterElemCount > 0" class="filter__entry">
                                <div class="filter__entry-count">
                                    Выбрано:
                                    <span class="filter__entry-count-num">{{ this.filterElemCount }}</span>
                                </div>
                                <button @click.prevent="clearFilter()" type="button" class="filter__entry-clear js-filter-clear">Очистить фильтр</button>
                            </div>

                            <div v-if="hasFilterRange(this.filterData.PRICE)" class="filter__item filter__item--range js-filter-item is-open">
                                <div class="filter__item-entry js-filter-entry"  @click="processFilterItemView($event)">
                                    <div class="filter__item-entry-title">Цена, ₽</div>
                                    <div class="filter__item-entry-arrow">
                                        <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                    </div>
                                </div>
                                <div class="filter__item-list js-filter-list-wp">
                                    <div class="filter__item-range-inputs">
                                        <div class="filter__item-range-inputs-container">

                                            <input type="text" aria-label="Цена товара" title="Цена товара" inputmode="decimal" id="filterNum1" :name="this.filterData.PRICE.VALUES.MIN.CONTROL_NAME" :data-value="Number(this.filterData.PRICE.VALUES.MIN.VALUE)" class="filter__item-range-prev js-filter-prev">
                                        </div>
                                        <div class="filter__item-range-inputs-container">

                                            <input type="text" aria-label="Цена товара" title="Цена товара" inputmode="decimal" id="filterNum2" :name="this.filterData.PRICE.VALUES.MAX.CONTROL_NAME" :data-value="Number(this.filterData.PRICE.VALUES.MAX.VALUE)" class="filter__item-range-next js-filter-next">
                                        </div>
                                    </div>
                                    <div class="catalog__filter-item-range-dragger js-filter-dragger" id="filterRange"></div>
                                </div>
                            </div>


                            <template v-for="item, key in this.filterData.ITEMS" :key="item.ID">

                                <template v-if="item.DISPLAY_TYPE == 'A' || item.DISPLAY_TYPE == 'B'">
                                    <div v-if="hasFilterRange(item)" class="filter__item filter__item--range js-filter-item is-open">
                                        <div class="filter__item-entry js-filter-entry" @click="processFilterItemView($event)">
                                            <div class="filter__item-entry-title" :class="{'filter__item-entry-title--hint': item.FILTER_HINT}">
                                                <span>{{ item.NAME }}</span>&#8288;<FilterHint :text="item.FILTER_HINT" :label="item.NAME"
                                                    :hint-id="'filter-hint-' + structKey + '-' + item.ID" />
                                            </div>
                                            <div class="filter__item-entry-arrow">
                                                <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                            </div>
                                        </div>
                                        <div class="filter__item-list js-filter-list-wp">
                                            <div class="filter__item-range-inputs">
                                                <div class="filter__item-range-inputs-container">

                                                    <input type="text" :aria-label="item.NAME"
                                                        :title="item.NAME"
                                                        inputmode="decimal"
                                                        :id="'filterNum1' + item.ID"
                                                        :name="item.VALUES.MIN.CONTROL_NAME"
                                                        :data-value="Number(item.VALUES.MIN.VALUE)"
                                                        class="filter__item-range-prev js-filter-prev">

                                                </div>
                                                <div class="filter__item-range-inputs-container">

                                                    <input type="text" :aria-label="item.NAME"
                                                        :title="item.NAME"
                                                        inputmode="decimal"
                                                        :id="'filterNum2' + item.ID"
                                                        :name="item.VALUES.MAX.CONTROL_NAME"
                                                        :data-value="Number(item.VALUES.MAX.VALUE)"
                                                        class="filter__item-range-next js-filter-next">

                                                </div>
                                            </div>
                                            <div class="catalog__filter-item-range-dragger js-filter-dragger" :id="'filterRange' + item.ID"></div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-if="item.VALUES && Object.keys(item.VALUES).length" class="filter__item js-filter-item is-open" :key="item.CODE" :data-code="item.CODE">
                                            <div class="filter__item-entry js-filter-entry" @click="processFilterItemView($event)">
                                                <div class="filter__item-entry-title" :class="{'filter__item-entry-title--hint': item.FILTER_HINT}">
                                                    <span>{{ item.NAME }}</span>&#8288;<FilterHint :text="item.FILTER_HINT" :label="item.NAME"
                                                        :hint-id="'filter-hint-' + structKey + '-' + item.ID" />
                                                </div>
                                                <div class="filter__item-entry-arrow">
                                                    <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                                </div>
                                            </div>
                                            <div class="filter__item-list js-filter-list-wp">
                                                <div class="filter__item-list-wp js-filter-list">
                                                    <label v-for="(val, index) in sortedFilterValues(item)"
                                                        v-show="expandedLists[item.ID] || index < filterListLimit(item)"
                                                        :key="val.CONTROL_ID" :for="val.CONTROL_ID" :class="{disabled: val.DISABLED}" class="filter__item-checkbox js-filter-list-item">
                                                        <input @change="setFilter()" :id="val.CONTROL_ID" :checked="val.CHECKED" :name="val.CONTROL_NAME" type="checkbox" :value="val.HTML_VALUE">
                                                        <span class="filter__item-checkbox-value">{{ val.VALUE }}</span>
                                                    </label>
                                                </div>
                                                <a v-if="isFilterListCollapsible(item)" href="#" @click.prevent="toggleFilterList(item)" class="filter-show-more js-filter-list-show" :class="{'is-active': expandedLists[item.ID]}">
                                                    <span class="js-filter-list-show-text">{{ expandedLists[item.ID] ? 'Скрыть' : 'Показать ещё' }}</span>
                                                    <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                                </a>
                                            </div>
                                        </div>
                                </template>

                            </template>

                        </div>
                        <div class="filter__mobile-btns">
                            <a href="#" @click.prevent="closeFilter($event)" class="btn btn--green filter__mobile-show js-filter-close">Применить</a>
                            <a href="#" @click.prevent="clearFilter()" class="btn btn--gray filter__mobile-show js-filter-close">Сбросить</a>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    `
}